import React, { Component } from 'react';
import Section from '../section/section';

class Sections extends Component {
    constructor() {
        super();
        this.state = {
            sections: []
        }
    }

    componentWillMount() {
        this.setState({
            sections: [
                {
                    title: "Military Service",
                    background: "./assets/img/smart.jpg",
                    backgroundColor: 'rgb(215, 238, 238)',
                    summary: "I worked in a team that did all the R&D phases from researching the internet and concept developing to distribution and customer support. This type of work demands creativity and outside the box thinking, research of the internet and development of new and breakthrough ideas, as well as interpersonal connections and direct work with non-technological customers. The fact that the team was not located close to most of the other R&D teams of the unit required us to develop autodidactic skills and cope with technological challenges by ourselves.",
                    entries: [
                        {
                            start: 2011,
                            end: 2014,
                            description: "Developer of Webint & Osint applications at the intelligence unit 8200: <ul><li>R&D of applications, data mining and processing it using .net & WPF. </li><li>Design and development of user friendly and intuitive user interfaces in various environments (Photoshop, Expression Blend etc.). </li><li>Single representative of unit 8200 in a special intelligence community project for half a year. </li><li>Working with various websites, using both their desktop and mobile versions, in addition to their API service. </li><li>Bypassing websites’ anti crawling mechanisms using proxies, JavaScript code analysis, and taking advantage of logical weaknesses and failures. </li><li>Fellow member of a team in charge of mining and processing data from Twitter, to analyze crowd perception. This project was awarded the “Mekor Chaim” prize for its technological and conceptual breakthrough by the unit’s commander. </li>Design and development, as a personal project, of an intelligence application for tracking and analyzing social media and other sources of information. This project was awarded the “Shviley Sadot” prize as an outstanding project of the Osint branch of unit 8200. </li><li>Fellow member of the R&D team that was nominated the best team of the Osint branch of unit 8200. </li><li>Working in cooperation with people inside and outside the unit. </li></ul>"
                        }
                    ]
                },
                {
                    title: "Courses",
                    background: "./assets/img/blue2.jpg",
                    summary: "",
                    entries: [
                        {
                            start: 2015,
                            end: 2015,
                            description: "Three weeks basic programming course led by technological teachers from the Prime Minister’s Office. The course included various programming languages and technologies such as MVC, WPF, Python, JavaScript, SQL, and C#. It developed team work and work skills, adapting the integrated developing environment (IDE)."
                        }
                    ]
                },
                {
                    title: "Professional Experience",
                    background: "./assets/img/blue3.jpg",
                    summary: "",
                    entries: [
                        {
                            start: 2013,
                            end: 2015,
                            description: "R&D team member of “KELA – Israeli Intelligence”, developing a client-server side tool for acquiring business intelligence from different sources in the web, aggregating and displaying it in a detailed yet simple and user friendly web interfaced report."
                        },
                        {
                            start: 2015,
                            end: 2016,
                            description: "Founding R&D team member of “MTN Technologies”, newly founded startup (Jan 2015), that develops a Big Data collecting system from the internet for advertising and marketing purposes."
                        },
                        {
                            start: 2017,
                            description: "Full stack freelance developer."
                        }
                    ]
                },
                {
                    title: "Education",
                    background: "./assets/img/blue1.jpg",
                    summary: "",
                    entries: [
                        {
                            start: 2007,
                            end: 2011,
                            description: "“Ohel-Shem” high school, Ramat-Gan. Technological diploma (35 units). <br/>Majors: mathematics, computer science, system developing and programming, physics, English. "
                        },
                        {
                            start: 2017,
                            description: "Student of the Open University. Studying computer science."
                        }
                    ]
                },
                {
                    title: "Skills",
                    background: "./assets/img/old.jpg",
                    summary: "",
                    entries: [
                        "Development of Windows and web applications, both client and server side.",
                        "Knowledge and experience in Microsoft’s MVVM design pattern.",
                        "Proficiency in creating rich yet simple and intuitive UX & UI.",
                        "High capability and motivation to independently learn new tools, skills & technologies.",
                        "Development of basic Android based applications.",
                        "Ability to work under pressure and tight schedule.",
                    ]
                }
            ]
        })
    }
    render() {
        let sections = this.state.sections.map(section => {
            return <Section {...section}/* key={section.title} summary={section.summary} title={section.title} background={section.background} entries={section.entries}*/ />
        });

        return (
            <div className="sections-wrapper">
                {sections}
            </div>
        );
    }
}

export default Sections;



// WEBPACK FOOTER //
// ./src/components/sections/sections.js